import type { Fraction } from "../shapes/common.js";
import { type BigFraction, bigFractionFromFraction } from "./BigFraction.js";

export const wrapFraction = (value: Fraction | null): BigFraction | null =>
  value === null ? null : bigFractionFromFraction(value);
